import { GetSavedSearchArgs } from 'types/api/arguments/get-saved-search-args'
import { GetSavedSearchResp } from 'types/api/response/get-saved-search-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getSavedSearch = ({ userId, id }: GetSavedSearchArgs) =>
  api.get<GetSavedSearchResp>(`/users/${userId}/searches/${id}`, {
    headers: moneyObjectHeader,
  })
